import styled, { RuleSet } from 'styled-components';

export const Section = styled.section<{
  $withBottomIndent: boolean;
  $styles?: RuleSet<object>;
}>`
  padding: 0 0 ${({ $withBottomIndent }) => ($withBottomIndent ? '15px' : '0')};
  ${({ $styles }) => $styles};
`;
